export default "__VITE_ASSET__BY1E7F6L__"